import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IBulkResponseRecord,
  IGetManyResponse,
  IGetOneResponse,
} from '../../shared/model/interface/crud-response-interface.model';
import {
  IBulkMoveMobileLogbooksModalDataResponse,
  IBulkMoveMobileLogbooksParams,
  IBulkMoveMobileLogbooksResponse,
} from './bulk-move-mobile-logbooks.model';
import { IIssuerAndReason } from '../../shared/component/before-action-preparer/before-action-preparer.model';

@Injectable({
  providedIn: 'root',
})
export class BulkMoveMobileLogbooksService {
  private readonly URLS = {
    GET_MOVABLE_LOGBOOKS: `${this.baseUrl}/logbooks/get-moveable-logbooks`,
    BULK_MOVE_MOBILE_LOGBOOKS: `${this.baseUrl}/logbook-versions/bulk-move-logbook`,
  };

  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  public getBulkMoveLogbookModalData(): Observable<IGetManyResponse<IBulkMoveMobileLogbooksModalDataResponse>> {
    return this.http.get<IGetManyResponse<IBulkMoveMobileLogbooksModalDataResponse>>(this.URLS.GET_MOVABLE_LOGBOOKS);
  }

  public bulkMoveMobileLogbooks(
    params: IBulkMoveMobileLogbooksParams,
    issuerAndReason: IIssuerAndReason | null,
  ): Observable<IBulkResponseRecord<IGetOneResponse<IBulkMoveMobileLogbooksResponse>>> {
    return this.http.post<IBulkResponseRecord<IGetOneResponse<IBulkMoveMobileLogbooksResponse>>>(
      this.URLS.BULK_MOVE_MOBILE_LOGBOOKS,
      {
        issuer: issuerAndReason?.issuer,
        payload: {
          sourceLogbooks: params.sourceLogbooks,
          destinationLogbook: params.destinationLogbook,
          reason: issuerAndReason?.reason,
        },
      },
    );
  }
}
